import { type ReactNode, useEffect } from 'react';

import { registerGsap, ScrollTrigger } from '@/lib/gsap';

/**
 * App-wide motion setup. Registers GSAP + plugins once, and refreshes
 * ScrollTrigger after the variable fonts finish loading — otherwise
 * SplitText and scroll positions are measured against fallback metrics and
 * every pinned/triggered section is a few pixels off.
 */
export function MotionProvider({ children }: { children: ReactNode }) {
  useEffect(() => {
    registerGsap();

    let cancelled = false;
    const refresh = () => {
      if (!cancelled) ScrollTrigger.refresh();
    };

    if (typeof document !== 'undefined' && 'fonts' in document) {
      document.fonts.ready.then(refresh).catch(() => {});
    }

    return () => {
      cancelled = true;
    };
  }, []);

  return <>{children}</>;
}
